/**
 * Normalizes a string to a valid GTM screen_name format.
 * Removes accents, special characters and replaces spaces with underscores.
 *
 * @example
 * normalizeScreenName('Hola que Tal')  // → 'hola_que_tal'
 * normalizeScreenName('¡Error de sesión!') // → 'error_de_sesion'
 */
export function normalizeScreenName(value: string): string {
  return value
    .replace(/<[^>]*>/g, '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s_]/g, '')
    .trim()
    .replace(/\s+/g, '_');
}
